import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { addressesApi } from '@/features/addresses/addressesApi';
import { auditApi } from '@/features/audit';
import { authApi } from '@/features/auth/authApi';
import { appealsApi } from '@/features/appeals/appealsApi';
import { connectionApplicationsApi } from '@/features/connectionApplications/connectionApplicationsApi';
import { consumptionApi } from '@/features/consumption/consumptionApi';
import { contactPersonPositionsApi } from '@/features/contactPersonPositions/contactPersonPositionsApi';
import { contractCasesApi } from '@/features/contractCases/contractCasesApi';
import { contractsApi } from '@/features/contracts/contractsApi';
import { dashboardApi } from '@/features/dashboard/dashboardApi';
import { financesApi } from '@/features/finances/financesApi';
import { industriesApi } from '@/features/industries/industriesApi';
import { meteringPointsApi } from '@/features/meteringPoints/meteringPointsApi';
import { organizationApi } from '@/features/organization/organizationApi';
import { organizationalLegalFormsApi } from '@/features/organizationalLegalForms/organizationalLegalFormsApi';
import { counterpartyUsersApi } from '@/features/counterpartyUsers/counterpartyUsersApi';
import { rolesApi } from '@/features/counterpartyUsers/rolesApi';
import uiSlice from '@/features/ui/uiSlice';

const rootReducer = combineReducers({
  [uiSlice.name]: uiSlice.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [auditApi.reducerPath]: auditApi.reducer,
  [counterpartyUsersApi.reducerPath]: counterpartyUsersApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
  [contractsApi.reducerPath]: contractsApi.reducer,
  [meteringPointsApi.reducerPath]: meteringPointsApi.reducer,
  [consumptionApi.reducerPath]: consumptionApi.reducer,
  [financesApi.reducerPath]: financesApi.reducer,
  [organizationApi.reducerPath]: organizationApi.reducer,
  [appealsApi.reducerPath]: appealsApi.reducer,
  [connectionApplicationsApi.reducerPath]: connectionApplicationsApi.reducer,
  [contractCasesApi.reducerPath]: contractCasesApi.reducer,
  [organizationalLegalFormsApi.reducerPath]: organizationalLegalFormsApi.reducer,
  [industriesApi.reducerPath]: industriesApi.reducer,
  [contactPersonPositionsApi.reducerPath]: contactPersonPositionsApi.reducer,
  [addressesApi.reducerPath]: addressesApi.reducer,
});

const middlewares = [
  authApi.middleware,
  auditApi.middleware,
  counterpartyUsersApi.middleware,
  rolesApi.middleware,
  dashboardApi.middleware,
  contractsApi.middleware,
  meteringPointsApi.middleware,
  consumptionApi.middleware,
  financesApi.middleware,
  organizationApi.middleware,
  appealsApi.middleware,
  connectionApplicationsApi.middleware,
  contractCasesApi.middleware,
  organizationalLegalFormsApi.middleware,
  industriesApi.middleware,
  contactPersonPositionsApi.middleware,
  addressesApi.middleware,
];

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewares),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
